<template>
  <div class="w-full flex justify-center pb-12 md:pb-20">
    <section class="flex flex-wrap justify-center items-center">
      <figure v-if="image" class="z-10 flex justify-center lg:justify-start w-full lg:w-auto mt-8">
        <img :src="image.url" :alt="headerText" class="clip-circle w-100 h-100 object-cover">
      </figure>

      <main class="text-center w-2/3 lg:text-left lg:pt-8 lg:pl-4 relative">
        <h2 class="h3 mb-3">{{ headerText }}</h2>
        <slot/>
        <button v-if="btn" class="mt-3">
          <nuxt-link :to="btnUrl" class="btn btn-secondary">
            {{ btnText }}
          </nuxt-link>
        </button>
      </main>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    headerText: {
      type: String,
      default: 'Header tekst',
    },
    btn: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: 'Button tekst',
    },
    btnUrl: {
      type: String,
      default: '/',
    },
    image: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.clip-circle {
  clip-path: circle(80px at center);
  width: 260px;
  height: 180px;
  @screen lg {
    clip-path: circle(120px at center);
    width: 260px;
    height: 300px;
  }
}
</style>
